
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporate/contactform/[...slug]",
      function () {
        return require("private-next-pages/corporate/contactform/[...slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporate/contactform/[...slug]"])
      });
    }
  